module.exports = __webpack_public_path__ + "static/img/3-EN.dcd324e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/3-EN.png
// module id = wkcd
// module chunks = 1